module.exports = "<p>\n  english works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// /Users/Guest/Desktop/meme/src/app/english/english.component.html
// module id = ../../../../../src/app/english/english.component.html
// module chunks = main